import ouiBase from '@goldwasserexchange/oui';
import { arDocHasFileName } from '../../../../shared';
import { useAccountHistoryTransformApiByHisMvtId } from '../api';

export const useAccountHistoryArDocHasFileName = () => {
  const hisMvtId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountHistoryTransformApiByHisMvtId({
    hisMvtId,
    transformFunction: arDocHasFileName,
  });
  return response;
};
